/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { ApplicationRef, EnvironmentInjector, Injectable, Injector, DOCUMENT, inject, createComponent } from '@angular/core'
import { lastValueFrom } from 'rxjs'
import { take } from 'rxjs/operators'
import { ModalTexts } from './modal-texts'
import { PidxPdsModalWrapperComponent } from './pidx-pds-modal-wrapper.component'

@Injectable({
  providedIn: 'root',
})
export class PidxPdsModalWrapperService {
  private environmentInjector = inject(EnvironmentInjector)
  private document = inject<Document>(DOCUMENT)
  private injector = inject(Injector)
  private app = inject(ApplicationRef)

  private _pidxPdsModalWrapperComponent!: PidxPdsModalWrapperComponent

  public versionCtrl: unknown

  constructor() {
    this.versionCtrl = (this.injector as unknown as { source?: string }).source
  }

  init() {
    // check if modal is already present in the DOM
    if (!this._pidxPdsModalWrapperComponent) {
      const newNode = this.document.createElement('div')
      newNode.id = 'pidxPdsModalAnchor_for_' + this.versionCtrl
      this.document.body.appendChild(newNode)

      const ref = createComponent(PidxPdsModalWrapperComponent, {
        environmentInjector: this.environmentInjector,
        elementInjector: this.injector,
        hostElement: newNode,
      })
      this.app.attachView(ref.hostView)
      this._pidxPdsModalWrapperComponent = ref.instance
    }
  }

  openModal(modalTexts: ModalTexts): Promise<boolean> {
    this.init()
    // open it
    this._pidxPdsModalWrapperComponent.data.set(modalTexts)
    this._pidxPdsModalWrapperComponent.openModal.set(true)

    return lastValueFrom(this._pidxPdsModalWrapperComponent.closeModalEvent.pipe(take(1)))
  }
}
